<template>

  <v-dialog v-model="val" persistent width="400">
    <v-card  color="primary" dark>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 pa-3 sm12>
            <v-layout justify-center full-width row wrap>
            <v-icon large color="white">{{iconname}}</v-icon>
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear></v-layout>
            </v-flex>
              <v-flex  xs12 sm12>
                 <v-layout justify-center full-width row wrap>
                <span class="subheading">{{mesaj}}, {{ $t('Please-Wait') }}...</span></v-layout></v-flex>
        </v-layout>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    props: ["value","mesaj","iconname"],
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },


    beforeMount: beforeMount,
    methods: {
    },
    data() {
      return {
      }
    },

    watch: {
    },
  }

  function beforeMount() {
  }

</script>